import type { Adjustment } from "@rogue/rackbuilder"
import type { RackOptions } from "../../../RackTypes"

// FT Shared Utilities — Pure helper functions shared across ALL functional trainer variants

// Flip on the X axis for right-side mirroring
export function getFlipX(left: boolean): Array<{ type: 'flip'; axis: 'X' }> {
  return left ? [] : [{ type: 'flip', axis: 'X' }]
}

// Flip on the Z axis for right-side mirroring
export function getFlipZ(left: boolean): Array<{ type: 'flip'; axis: 'Z' }> {
  return left ? [] : [{ type: 'flip', axis: 'Z' }]
}

// Rotate 180° on Y then flip on X — used for rail/crossmember mirroring
export function getRotateAndFlipX(left: boolean): Adjustment[] {
  return left
    ? []
    : [
      { type: 'rotate', axis: 'Y', amount: 180 },
      { type: 'flip', axis: 'X' },
    ]
}

// Turn value into inches
export function getDepthInInches(config: RackOptions): string {
  if (config.depth === '4') return '43'
  if (config.depth === '2') return '24'

  return '30'
}
